/**
 * Cost Service
 * Register Angular Services for all things Cost
 *
 * @package:  Betta
 * @version:  2.1
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Cost', ['$resource', function($resource){
    return $resource('/api/v3/cost/:id', null, {
        'update': { method:'PUT' }
    });
}]);
